(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-highlight-collection"] && !Shopify.designMode) return;
  try {
    
$('.product-highlight-link').click(function(e) {
  if(e) {
    e.preventDefault();
  }
  $('.product-highlight-link').removeClass('active');
  $(this).addClass('active');
  $('.productHighlightContent').removeClass('visible');
  $($(this).attr('href')).addClass('visible');
});

  } catch(e) { console.error(e); }
})();
})();
